<ng-container *ngIf="!lmColumnLayoutInfo.imageInFirstColumn">
  <div *ngFor="let col of columns; trackBy: trackByIndex;" class="lm-column">
    <lm-element
      *ngIf="col"
      [layoutObject]="col"
      [layoutInfo]="layoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-element>
  </div>
</ng-container>
